module.exports = __webpack_public_path__ + "img/3.96707907.jpg";